import axios from 'axios'
// Lightly check if pdf exists at url already
// Refactored to a promise that tries it's best to return
// something in all error scenarios.
export async function urlExists(url) {
  try {
    const res = await axios.head(url)
    return res && res.status === 200 ? url : false
  } catch {
    return false
  }
}

export default urlExists
